module.exports = __webpack_public_path__ + "static/media/download-icon.b4e30bd8.svg";